import API_BASE_URL from '../config/api';

export const getDashboardFlyerUrl = (value: string, apiBase = API_BASE_URL): string => {
  const candidate = value.trim();
  if (!candidate) return '';

  try {
    const url = new URL(candidate, window.location.origin);
    if (!['localhost', '127.0.0.1', '[::1]'].includes(url.hostname)) return candidate;

    const normalizedApiBase = apiBase.replace(/\/+$/, '');
    const apiPath = url.pathname.startsWith('/api/')
      ? url.pathname.slice('/api'.length)
      : url.pathname;
    return `${normalizedApiBase}${apiPath}${url.search}${url.hash}`;
  } catch {
    return candidate;
  }
};
